let apiUrl = 'https://apidev.imaginary.software/api';
let baseUrl = 'https://apidev.imaginary.software';
const localapi = true;

if (process.env.REACT_APP_ENVIRONMENT === 'production') {
  apiUrl = 'https://api.imaginary.software/api';
  baseUrl = 'https://api.imaginary.software';
} else if (localapi && window.location.host.match(/localhost/)) {
  apiUrl = 'https://apidev.imaginary.software/api';
  baseUrl = 'https://apidev.imaginary.software';
}

export { apiUrl, baseUrl };
